/**
 * This helper file provides a workaround for Zod import issues in Vercel deployment
 */

// Try to import Zod directly if possible
let z: any;

try {
  // Dynamic import to avoid build-time issues
  z = require('zod');
} catch (e) {
  // Fallback to window.Zod if available (from CDN)
  if (typeof window !== 'undefined' && window.Zod) {
    z = window.Zod;
  } else {
    // Create a minimal placeholder if neither is available
    z = {
      object: () => ({
        min: () => ({}),
        shape: () => ({}),
      }),
      string: () => ({
        min: () => ({}),
        optional: () => ({}),
      }),
      date: () => ({}),
      coerce: {
        number: () => ({
          min: () => ({}),
        }),
      },
      array: () => ({
        min: () => ({}),
      }),
      enum: () => ({}),
      infer: (schema: any) => ({}),
    };
  }
}

export default z;
